import { CRUD_LABEL_PROPS } from "./CrudLabelProps.js";

export const CRUD_SELECT_PROPS = {
	id: {
		required: true,
		type: String,
		default: ""
	},
	name: {
		required: true,
		type: String
	},
	placeholder: {
		required: true,
		type: String,
		default: ""
	},
	options: {
		required: true,
		type: Array
	},
	validationRules: {
		required: false,
		type: Object,
		default: null
	},
	isDisabled: {
		required: false,
		type: Boolean,
		default: false
	},
	errorsClassList: {
		required: false,
		type: String,
		default: ""
	},
	value: {
		required: false,
		type: [String, Number]
	},
	isManagementListener: {
		required: false,
		type: Boolean,
		default: false
	},

	...CRUD_LABEL_PROPS
}
